import queryKeys from '@/constants/queryKeys';
import { growthZoneGet } from '@/services/api/requests/growthZone';
import { useAppStore } from '@/store/useAppStore';
import { useQuery } from '@tanstack/react-query';

const useGrowthZone = () => {
  const { user } = useAppStore();

  const { isLoading, data, isError, error, isRefetching, refetch, isSuccess } = useQuery({
    queryKey: [queryKeys.growthZone.goals, user?.email],
    queryFn: async () => {
      const response = await growthZoneGet();

      return response;
    },
  });

  return { isLoading, data, isError, error, isRefetching, refetch, isSuccess };
};

export { useGrowthZone };
